<div *ngIf="post && (post.hasVideo || post.hasImage)" [ngClass]="{ 'display-flex': post.hasImage}">
    <img [src]="post.formattedImage" fetchpriority="low" *ngIf="post.hasImage" alt="image-file" class="clickable" (click)="viewImage()" />
    <ng-container *ngIf="post.hasVideo">
        <app-user-post-video-player *appInView [srcs]="post.videoSources" [options]="{ fluid: true }"></app-user-post-video-player>
    </ng-container>
</div>
